import type { EmptyChatSuggestion } from '@ztechapps/ai.webui'
import { AiChatBubble, DEFAULT_SUGGESTIONS, useChatPageContext } from '@ztechapps/ai.webui'
import { useOpenPivotContext } from '@ztechapps/webui.reporting'
import { ShowIf } from '@ztechapps/webui.util'
import { routesDef } from '../../config/routes'
import { useChatBubbleVisibilityContext } from './Context'

const PIVOT_PAGE_SUGGESTIONS: EmptyChatSuggestion[] = [
  ...DEFAULT_SUGGESTIONS,
  { icon: 'wand-magic-sparkles', text: 'Build this report for me…' },
]

export const AdminChatBubble = () => {
  const { isChatBubbleVisible } = useChatBubbleVisibilityContext()
  const { openPivot } = useOpenPivotContext()
  const pageContext = useChatPageContext()

  return (
    <ShowIf condition={isChatBubbleVisible}>
      <AiChatBubble
        isDraggable
        productUrl={(p) => routesDef.ProductItemPage.altPath({ _id: p._id })}
        blogUrl={(b) =>
          b.slug ? routesDef.BlogPreviewPage.altPath({ slug: b.slug }) : routesDef.BlogItemPage.altPath({ _id: b._id })
        }
        orderUrl={(o) => routesDef.OrderItemPage.altPath({ _id: o._id })}
        purchaseOrderUrl={(po) => routesDef.PurchaseItemPage.altPath({ _id: po._id })}
        emptyChatSuggestions={openPivot ? PIVOT_PAGE_SUGGESTIONS : undefined}
        pageContext={pageContext}
      />
    </ShowIf>
  )
}
